module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter"
  }, [_c('p', {
    staticClass: "ded",
    attrs: {
      "id": "ack"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_6"
    }
  }, [_vm._v("ACKNOWLEDGMENTS")])]), _c('a', {
    attrs: {
      "id": "page_6"
    }
  }, [_c('p', {
    staticClass: "ded"
  }, [_vm._v("A great big THANK-YOU must go to Pistol Pete Cormican, premier DJ of Dallas, Texas, and one of the most open and generous men with whom it was ever my pleasure to speak.")]), _vm._v(" "), _c('p', {
    staticClass: "ded"
  }, [_vm._v("By telephone he helped me through the geography of his fine city, leading me through the maze of streets and suburbs with patience and ease.")]), _vm._v(" "), _c('p', {
    staticClass: "ded"
  }, [_vm._v("Any physical discrepancies you might find in various locations are nothing more than creative license, and any mistakes are mine, not his.")])])]), _c('a', {
    attrs: {
      "id": "page_6"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-32e165a7","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/ack.vue
// module id = 78
// module chunks = 0